import extendAuthModalsWithTurnstile from './extendAuthModals';
extendAuthModalsWithTurnstile();